import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { quickReports } from '../../data/demandes';
import { AtnaConversationDialog } from './AtnaConversationDialog';
import { PromptBox } from './PromptBox';
const PANEL_LAYOUT_ID = 'atna-conversation-panel';
interface RequestComposerProps {
  /** Action affichée à droite de la barre ATNA (ex. « Nouvelle demande »). */
  action?: React.ReactNode;
}
export function RequestComposer({
  action
}: RequestComposerProps) {
  const [draft, setDraft] = useState('');
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  const [direct, setDirect] = useState(false);
  const open = (value: string, fromShortcut = false) => {
    const text = value.trim();
    if (!text) return;
    setOpenedWith(text);
    setDirect(fromShortcut);
    setDraft('');
  };
  const isOpen = openedWith !== null;
  return <section aria-label="Signaler un problème avec ATNA" data-id="element-1308" data-mp="x80ylzfd56zd">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-6" data-id="element-1309" data-mp="x9ltjq5larxr">
      <div className="min-w-0 lg:max-w-[720px] lg:flex-1" data-id="element-1310" data-mp="1kah1h77pj1lw">
        {isOpen ?
        // Placeholder keeps the page from jumping while the pill morphs into the dialog.
        <div className="h-[66px]" aria-hidden="true" data-id="element-1311" data-mp="1tan9weojtbe7" /> : <motion.div layoutId={PANEL_LAYOUT_ID} style={{
          borderRadius: 999
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-1312" data-mp="1t7rccrgm4oqa">
            <PromptBox value={draft} onChange={setDraft} onSubmit={() => open(draft)} onAddPhoto={() => open(draft)} variant="hero" placeholder="Que voulez-vous signaler ?" data-id="element-1313" data-mp="237i4wnlm4tnq" />
          </motion.div>}
      </div>
      {action && <div className="shrink-0 self-start lg:ml-auto lg:self-center" data-id="element-1314" data-mp="27zjqj04o7wqf">{action}</div>}
      </div>

      <ul className="-mx-5 mt-4 flex snap-x gap-2.5 overflow-x-auto px-5 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-1315" data-mp="2lzaz2lcf4kx1">
        {quickReports.map(quick => <li key={quick} className="shrink-0 snap-start" data-id="element-1316" data-mp="1en3863hcwjjd">
            <button type="button" onClick={() => open(quick, quick === 'Nid-de-poule')} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1317" data-mp="1ekgzg0iqbxzk">
              {quick}
            </button>
          </li>)}
      </ul>

      <AnimatePresence data-id="element-1318" data-mp="26dpthc2q48yu">
        {openedWith !== null && <AtnaConversationDialog key="atna-dialog" initialText={openedWith} direct={direct} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} data-id="element-1319" data-mp="26e9a8pgn0rba" />}
      </AnimatePresence>
    </section>;
}